// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Sentry = require("../../../reason/Sentry.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let ReactErrorBoundary = require("react-error-boundary");

function FragmentErrorBoundary$ErrorState(props) {
  return JsxRuntime.jsx("div", {
    children: `⚠ Error retrieving ` + props.fragmentDisplayName,
    className: "text-tan-error-500 font-medium"
  });
}

let ErrorState = {
  make: FragmentErrorBoundary$ErrorState
};

function FragmentErrorBoundary(props) {
  let fragmentDisplayName = props.fragmentDisplayName;
  return JsxRuntime.jsx(ReactErrorBoundary.ErrorBoundary, {
    FallbackComponent: _error => JsxRuntime.jsx(FragmentErrorBoundary$ErrorState, {
      fragmentDisplayName: fragmentDisplayName
    }),
    children: props.children,
    onError: error => Sentry.captureException(error, "FragmentErrorBoundary.res", undefined, undefined, undefined)
  });
}

let make = FragmentErrorBoundary;

exports.ErrorState = ErrorState;
exports.make = make;
/* Sentry Not a pure module */
